@let _activeTab = activeTab();
@let showTabs = configService.pmSystem === PmSystem.CCH_AXCESS && areUnsentTabsEnabled();

<div class="edh-toolbar" [attr.data-density]="toolbarDensity()" edhResponsiveToolbar (densityChange)="toolbarDensity.set($event)">
  @if (showTabs) {
    <div class="edh-toolbar__tabs table-filter-tab-container d-flex w-fit-content" data-toolbar-tabs role="tablist" aria-label="Email delivery phase tabs">
      <div
        class="d-flex justify-content-center align-items-center table-filter-tab"
        [ngClass]="{ selected: _activeTab === EmailDeliveryTab.SENT }"
        [attr.aria-selected]="_activeTab === EmailDeliveryTab.SENT"
      >
        <button
          role="tab"
          type="button"
          dataSelector="email-delivery-tab-sent"
          (click)="onTabChange(EmailDeliveryTab.SENT)"
        >
          Sent
        </button>
      </div>

      <div
        tooltip="These records are waiting on data from your practice management system. Our system will automatically retry them once the required data syncs."
        class="d-flex justify-content-center align-items-center table-filter-tab"
        [ngClass]="{ selected: _activeTab === EmailDeliveryTab.PENDING }"
        [attr.aria-selected]="_activeTab === EmailDeliveryTab.PENDING"
      >
        <button
          role="tab"
          type="button"
          dataSelector="email-delivery-tab-pending"
          class="d-flex align-items-center gap-1"
          (click)="onTabChange(EmailDeliveryTab.PENDING)"
        >
          Pending
          @if (pendingCount() > 0) {
            <pill [value]="pendingCount() | numberAbbr" color="yellow" size="small" />
          }
        </button>
      </div>

      <div
        tooltip="These records could not be sent as emails, and our system will not automatically resolve them. Review each record and take the appropriate action."
        class="d-flex justify-content-center align-items-center table-filter-tab"
        [ngClass]="{ selected: _activeTab === EmailDeliveryTab.FAILED }"
        [attr.aria-selected]="_activeTab === EmailDeliveryTab.FAILED"
      >
        <button
          role="tab"
          type="button"
          dataSelector="email-delivery-tab-failed"
          class="d-flex align-items-center gap-1"
          (click)="onTabChange(EmailDeliveryTab.FAILED)"
        >
          Failed
          @if (failedCount() > 0) {
            <pill [value]="failedCount() | numberAbbr" color="red" size="small" />
          }
        </button>
      </div>
    </div>
  }

  <app-email-delivery-hub-filters
    class="edh-toolbar__filters"
    data-toolbar-filters
    [density]="toolbarDensity()"
    [activeTab]="_activeTab"
    [gridApi]="activeGridApi()"
  >
    @if (exportConfig(); as cfg) {
      <app-ag-grid-export-all-button
        export-slot
        dataSelector="email-delivery-hub-export-button"
        [tableId]="cfg.tableId"
        [gridApi]="cfg.gridApi"
        [columnApi]="cfg.columnApi"
        [defaultColumnDef]="cfg.defaultColumnDef"
        [columnDefs]="cfg.columnDefs"
        [gridOptions]="cfg.gridOptions"
        [externalFilters]="cfg.externalFilters"
        [createDatasource]="cfg.createDatasource"
        [getExportParams]="cfg.getExportParams"
      />
    }
  </app-email-delivery-hub-filters>
</div>

<!-- Tab content -->
@if (_activeTab === EmailDeliveryTab.SENT) {
  @let metricsData = metricsData$ | async;
  @if (metricsData) {
    @switch (metricsData.status) {
      @case (LoadableStatus.LOADED) {
        @let data = metricsData.data;
        <app-email-delivery-hub-insights
          [metricsToShow]="data.metricUnits"
          [total]="data.total"
          [comparisonDateRange]="data.comparisonDateRange"
        />
      }
      @case (LoadableStatus.ERROR) {
        <div class="email-delivery-hub-metrics-loading-container">
          <div class="alert alert--error">Failed to load email metrics. Please try again later.</div>
        </div>
      }
      @default {
        <div class="email-delivery-hub-metrics-loading-container">
          <mat-progress-spinner [diameter]="35" mode="indeterminate" />
        </div>
      }
    }
  }
  <app-email-delivery-hub-sent-table
    (gridApiReady)="activeGridApi.set($event)"
    (exportConfigReady)="exportConfig.set($event)"
  />
}
@if (_activeTab === EmailDeliveryTab.PENDING) {
  <app-email-delivery-hub-pending
    (gridApiReady)="activeGridApi.set($event)"
    (exportConfigReady)="exportConfig.set($event)"
    (countChange)="pendingCount.set($event)"
  />
}
@if (_activeTab === EmailDeliveryTab.FAILED) {
  <app-email-delivery-hub-failed
    (gridApiReady)="activeGridApi.set($event)"
    (exportConfigReady)="exportConfig.set($event)"
    (countChange)="failedCount.set($event)"
  />
}
